import { buildManagePageQueryString } from "./helpers/buildManagePageQueryString";
import { jumboMediaAPI } from "./service";

export const campaignAPI = jumboMediaAPI.injectEndpoints({
    endpoints: (build) => ({
        getCampaignForPage: build.query({
            query: body => ({
                url: `/api/Campaigns/GetCampaignForPage?campaign_id=${body.id}`,
            }),
            providesTags: ["Projects"],
        }),
        getCampaigns: build.query({
            query: ({ columns, page, searchTerm, limit, orderColumnIndex, isDescSortDir }) => ({
                url: `/api/Campaigns/DataTablesSource${buildManagePageQueryString(columns, page, searchTerm, (page - 1) * limit, limit, orderColumnIndex, isDescSortDir)}`,
            }),
            providesTags: ["Projects"],
        }),
        getCampaignList: build.query({
            query: ({ itemPerPage = 10, pageNumber = 0, actionNeed, statusName, search = null, filter = null, sorting, }) => ({
                url: `/api/Campaigns/GetCampaignsForTable?itemPerPage=${itemPerPage}&pageNumber=${pageNumber}&actionNeeded=${actionNeed ? 'true' : 'false'}&status=${statusName || ''}&search=${search}&filter=${filter}&sorting=${sorting === 'num' ? 'num_asc' : 'num_desc'}`,
            }),
            providesTags: ["Projects"],
        }),
        getAllCampaigns: build.query({
            query: (body) => ({
                url: `/api/Campaigns/UserGet?projectId=${body.projectId}`,
                responseHandler: (res: any) => res.json().then((res: any) => {
                    if (body?.asSelectOptions) {
                        return res.map((item: any) => ({ value: item.CampaignId, label: `${item.Name || item.CampaignId}`, toString: () => item.CampaignId }))
                    } else {
                        return res;
                        // .map((item: any) => ({ id: item.Id, name: item.Name }))
                    }
                }),
            }),
            providesTags: ["Projects"],
        }),
        deleteCampaign: build.mutation({
            query: body => ({
                url: `/api/Campaigns/AdminDelete/${body.id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ["Projects"],
        }),
        userDeleteCampaign: build.mutation({
            query: body => ({
                url: `/api/Campaigns/UserDelete/${body.id}`,
                method: 'GET',
            }),
            invalidatesTags: ["Projects"],
        }),
        changeCampaignNumber: build.mutation({
            query: body => ({
                url: `/api/campaigns/changeCampaignToProject`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Projects'],
        }),
        getPreviewFile: build.query({
            query: (body) => ({
                url: body.link,
            }),
        }),
        locateCampaign: build.query({
            query: body => ({
                url: `api/Campaigns/Locate?campaign_id=${body.campaignId}&brand_id=${body.brandId}`
            }),
        }),
    }),
});

export const {
    useGetCampaignsQuery,
    useLazyGetCampaignsQuery,
    useDeleteCampaignMutation,
    useGetAllCampaignsQuery,
    useLazyGetAllCampaignsQuery,
    useChangeCampaignNumberMutation,
    useGetPreviewFileQuery,
    useLazyGetPreviewFileQuery,
    useGetCampaignListQuery,
    useGetCampaignForPageQuery,
    useLocateCampaignQuery,
    useLazyLocateCampaignQuery,
    useUserDeleteCampaignMutation,
} = campaignAPI;